import { Button, Group, Popover, SimpleGrid, Stack, Text, UnstyledButton } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBook2, IconChevronDown, IconExternalLink } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { docGroups, type DocLink } from "../lib/docs";

function DocItem({ link, onNavigate }: { link: DocLink; onNavigate: () => void }) {
  const body = (
    <Group gap={8} wrap="nowrap" align="flex-start" px={8} py={6} className="pd-doc-link">
      {link.icon ? <link.icon size={16} style={{ marginTop: 2, flexShrink: 0 }} color="var(--pd-violet)" /> : <span style={{ width: 16, flexShrink: 0 }} />}
      <Stack gap={0} style={{ minWidth: 0, flex: 1 }}>
        <Group gap={4} wrap="nowrap">
          <Text fz="sm" fw={600}>
            {link.label}
          </Text>
          {!link.internal && <IconExternalLink size={11} color="var(--mantine-color-dimmed)" />}
        </Group>
        {link.description && (
          <Text fz={11} c="dimmed">
            {link.description}
          </Text>
        )}
      </Stack>
    </Group>
  );
  return link.internal ? (
    <UnstyledButton component={Link} to={link.href} onClick={onNavigate}>
      {body}
    </UnstyledButton>
  ) : (
    <UnstyledButton component="a" href={link.href} target="_blank" rel="noreferrer" onClick={onNavigate}>
      {body}
    </UnstyledButton>
  );
}

/** Header dropdown with every documentation link: API reference, GitBook, mobile SDKs, Easy AI. */
export function DocsMenu() {
  const [opened, { toggle, close }] = useDisclosure(false);
  const groups = docGroups();
  return (
    <Popover opened={opened} onChange={(o) => !o && close()} width={600} position="bottom-end" shadow="lg" radius="md" withArrow>
      <Popover.Target>
        <Button variant="subtle" color="gray.0" onClick={toggle} leftSection={<IconBook2 size={17} />} rightSection={<IconChevronDown size={14} />} px={10} aria-label="Documentation" styles={{ section: { margin: 0 } }}>
          <Text fz="sm" fw={600} visibleFrom="sm" mx={6}>
            Docs
          </Text>
        </Button>
      </Popover.Target>
      <Popover.Dropdown p="sm" mah="80vh" maw="calc(100vw - 16px)" style={{ overflowY: "auto" }}>
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" verticalSpacing="sm">
          {groups.map((g) => (
            <Stack key={g.label} gap={2}>
              <Text fz={11} fw={700} c="dimmed" tt="uppercase" px={8} style={{ letterSpacing: "0.06em" }}>
                {g.label}
              </Text>
              {g.links.map((l) => (
                <DocItem key={l.href} link={l} onNavigate={close} />
              ))}
            </Stack>
          ))}
        </SimpleGrid>
      </Popover.Dropdown>
    </Popover>
  );
}
